module.exports = __webpack_public_path__ + "media/images/emblems/Bellach-blason-77012356117607ee1cff257a3405c449.png";